<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-container fluid>
      <div>
        <b-card header-tag="header">
          <template #header>
            <card-title>
              <b-icon class="icono" icon="file-text"></b-icon>Disponibilidad de
              cita
            </card-title>
          </template>
          <b-card-body>
            <b-row class="text-center">
              <b-col sm="4">
                <div class="entradasreporte form-inline" style="display:flex;">
                  <label class="labelderecha" for="example-datepicker"
                    >Fecha inicial</label
                  >
                  <b-form-datepicker
                    id="example-datepicker"
                    locale="es-MX"
                    v-model="valueFechaInicial"
                    class="muevecalendario"
                    labelNoDateSelected="Escoga una fecha"
                    @click.native="actualizarFechaFinal()"
                  ></b-form-datepicker>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="entradasreporte form-inline">
                  <label class="labelderecha" for="region">Región</label>
                  <b-form-select
                    id="region"
                    v-model="selectedRegion"
                    :options="optionsRegion"
                    @change="obtenerClinicas(selectedRegion)"
                    size="sm"
                    class="mt-3"
                  ></b-form-select>
                  <div class="mt-3"></div>
                </div>
              </b-col>

              <b-col sm="4">
                <div class="entradasreporte multipleselect">
                  <label class="labelmultiselect" for="clinica">Clínica</label>
                  <div>
                    <b-form-select
                      id="clinica"
                      v-model="selectedClinicas"
                      :options="optionsClinicas"
                      :disabled="deshabilitarClinicas"
                      @change="obtenerDoctores()"
                      multiple
                      :select-size="4"
                    ></b-form-select>
                    <div class="mt-3"></div>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row class="text-center">
              <b-col sm="6">
                <div class="entradasreporte multipleselect">
                  <label class="labelmultiselect" for="especialidades"
                    >Especialidades</label
                  >
                  <div>
                    <b-form-select
                      v-model="selectedEspecialidades"
                      :options="optionsEspecialidades"
                      @change="obtenerDoctores()"
                      multiple
                      :select-size="4"
                    ></b-form-select>
                    <div class="mt-3"></div>
                  </div>
                </div>
              </b-col>

              <b-col sm="6">
                <div class="entradasreporte form-inline">
                  <label class="labelderecha" for="doctor">Doctor</label>
                  <b-form-select
                    id="doctor"
                    v-model="selectedDoctor"
                    :disabled="deshabilitarDoctor"
                    :options="optionsDoctores"
                    size="sm"
                    class="mt-3 form-group"
                  ></b-form-select>
                  <div class="mt-3"></div>
                </div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col sm="4">
                <div class="entradasreporte form-inline" style="display:flex">
                  <label class="labelderecha" for="rangocita">Rango cita</label>
                  <b-form-select
                    id="rangocita"
                    v-model="selectedRangocita"
                    :options="optionsRangocita"
                    size="sm"
                    class="mt-3"
                  ></b-form-select>
                  <div class="mt-3"></div>
                </div>
              </b-col>
            </b-row>

            <b-row class="text-center">
              <b-col sm="12">
                <b-button
                  v-on:click="obtenerDisponibilidadPorClinica()"
                  class="entradasreporte botonesmargin"
                  variant="outline-primary"
                  >Ejecutar reporte</b-button
                >
              </b-col>
            </b-row>

            <b-row class="text-center">
              <b-col sm="12">
                <div
                  class="table table-striped table-bordered table-sm"
                  style="overflow:auto;"
                >
                  <b-table
                    striped
                    hover
                    :items="items"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    thead-tr-class="columnas"
                    caption-top
                  >
                    <template #table-caption>Disponibilidad de cita</template>
                  </b-table>
                  <b-col>
                    <b-alert v-if="datosTabla === 0" variant="warning" show
                      >No hay datos</b-alert
                    >
                  </b-col>
                  <div class="row" style="display:inline-block">
                    <div class="col-md-8 offset-md-2">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import ax from "axios";
import Header from "../../components/Header.vue";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    datosTabla: 0,
    valueFechaInicial: "",
    valueFechaFinal: "",
    context: null,
    selectedRegion: 0,
    selectedDoctor: 0,
    selectedClinicas: [],
    selectedRangocita: 60,
    deshabilitarClinicas: true,
    deshabilitarDoctor: true,
    selectedEspecialidades: [0],
    optionsRegion: [],
    optionsClinicas: [],
    optionsEspecialidades: [],
    optionsDoctores: [],
    perPage: 15,
    currentPage: 1,
    fields: [
      {
        key: "clinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "horario_ini",
        label: "Horario inicio",
        sortable: true,
      },
      {
        key: "horario_end",
        label: "Horario fin",
        sortable: true,
      },
      {
        key: "dias_esperah",
        label: "Hoy",
        sortable: true,
      },
      {
        key: "dias_espera1s",
        label: "En 1 semana",
        sortable: true,
      },
      {
        key: "dias_espera2s",
        label: "En 2 semana",
        sortable: true,
      },
      {
        key: "dias_espera1m",
        label: "En 1 mes",
        sortable: true,
      },
      {
        key: "dias_espera2m",
        label: "En 2 meses",
        sortable: true,
      },
    ],
    items: [],
    optionsRangocita: [
      { value: "15", text: "15 minutos" },
      { value: "30", text: "30 minutos" },
      { value: "60", text: "60 minutos" },
      { value: "90", text: "90 minutos" },
      { value: "120", text: "120 minutos" },
    ],
  }),
  methods: {
    showAlert() {
      Swal.fire({
        title: "Se esta ejecutando el reporte",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
    validacionFecha() {
      if (this.valueFechaInicial == "" && this.valueFechaFinal == "") {
        Swal.fire({
          title: "Por favor selecciona la fecha inicial del reporte",
          confirmButtonText: "Aceptar",
        });
        return false;
      } else {
        return true;
      }
    },
    onContext(ctx) {
      this.context = ctx;
    },
    deshabilitarRangoCita: function() {
      if (this.selectedRegion == 0) {
        this.optionsRangocita = [
          { value: "15", text: "15 minutos", disabled: true },
          { value: "30", text: "30 minutos", disabled: true },
          { value: "60", text: "60 minutos" },
          { value: "90", text: "90 minutos" },
          { value: "120", text: "120 minutos" },
        ];
      } else {
        this.optionsRangocita = [
          { value: "15", text: "15 minutos" },
          { value: "30", text: "30 minutos" },
          { value: "60", text: "60 minutos" },
          { value: "90", text: "90 minutos" },
          { value: "120", text: "120 minutos" },
        ];
      }
    },
    validacionesReporte: function() {
      if (
        this.selectedRegion == 0 &&
        (this.selectedEspecialidades.includes(0) ||
          this.selectedEspecialidades.length == 0 ||
          this.selectedEspecialidades.length > 1)
      ) {
        Swal.fire({
          title: "Esta opción esta deshabilitada por el momento",
          confirmButtonText: "Aceptar",
        });
        return false;
      } else {
        return true;
      }
    },
    obtenerDisponibilidadPorClinica: function() {
      if (!this.validacionesReporte()) {
        return false;
      }
      this.showAlert();
      const _this = this;
      if (!this.validacionFecha()) {
        return false;
      }
      _this.items = [];

      let temporalDoctor;
      let temporalClinica = [];
      let temporalEspecialidades;
      temporalDoctor = this.selectedDoctor;
      if (this.selectedEspecialidades.includes(0)) {
        temporalEspecialidades = [];
      } else {
        temporalEspecialidades = this.selectedEspecialidades;
      }
      if (this.selectedRegion != 0) {
        this.fields = [
          {
            key: "clinica",
            label: "Clinica",
            sortable: true,
          },
          {
            key: "horario_ini",
            label: "Horario inicial",
            sortable: true,
          },
          {
            key: "horario_end",
            label: "Horario final",
            sortable: true,
          },
          {
            key: "dias_esperah",
            label: "Hoy",
            sortable: true,
          },
          {
            key: "dias_espera1s",
            label: "En 1 semana",
            sortable: true,
          },
          {
            key: "dias_espera2s",
            label: "En 2 semana",
            sortable: true,
          },
          {
            key: "dias_espera1m",
            label: "En 1 mes",
            sortable: true,
          },
          {
            key: "dias_espera2m",
            label: "En 2 meses",
            sortable: true,
          },
        ];
        if (this.selectedDoctor == 0) {
          temporalDoctor = [];
        } else {
          temporalDoctor = [this.selectedDoctor];
        }
        if (this.selectedClinicas.length == 0) {
          let contador = 0;
          let peticion = this.$apiUrl + "obtenerMatriz" + this.$apiToken;
          this.optionsClinicas.forEach(function(value) {
            temporalClinica.push(value.value);

            var data = {
              iniDate: _this.valueFechaInicial,
              endDate: _this.valueFechaFinal,
              cutTime: _this.selectedRangocita,
              cliId: [value.value],
              docId: temporalDoctor,
              spcId: temporalEspecialidades,
            };

            ax.post(peticion, data)
              .then((response) => {
                if (response.data.data.length == 0) {
                  _this.datosTabla = 0;
                } else {
                  _this.datosTabla = 1;
                }
                contador = contador + 1;
                if (_this.optionsClinicas.length == contador) {
                  Swal.close();
                }
                response.data.data.forEach(function(value) {
                  _this.items.push(value);
                });
              })
              .catch((response) => {
                console.error(response);
                contador = contador + 1;
                if (_this.optionsClinicas.length == contador) {
                  Swal.close();
                }
              });
          });
        } else if (
          this.optionsEspecialidades.length == 0 ||
          this.optionsEspecialidades.includes(0)
        ) {
          let contador = 0;

          let peticion = this.$apiUrl + "obtenerMatriz" + this.$apiToken;
          this.selectedClinicas.forEach(function(value) {
            temporalClinica.push(value);
            var data = {
              iniDate: _this.valueFechaInicial,
              endDate: _this.valueFechaFinal,
              cutTime: _this.selectedRangocita,
              cliId: [value],
              docId: temporalDoctor,
              spcId: temporalEspecialidades,
            };
            ax.post(peticion, data)
              .then((response) => {
                if (response.data.data.length == 0) {
                  _this.datosTabla = 0;
                } else {
                  _this.datosTabla = 1;
                }
                contador = contador + 1;
                if (_this.selectedClinicas.length == contador) {
                  Swal.close();
                }
                response.data.data.forEach(function(value) {
                  _this.items.push(value);
                });
              })
              .catch((response) => {
                contador = contador + 1;
                if (_this.selectedClinicas.length == contador) {
                  Swal.close();
                }
                console.error(response);
              });
          });
        } else {
          let contador = 0;

          let peticion = this.$apiUrl + "obtenerMatriz" + this.$apiToken;

          this.selectedClinicas.forEach(function(value) {
            temporalClinica.push(value);

            var data = {
              iniDate: _this.valueFechaInicial,
              endDate: _this.valueFechaFinal,
              cutTime: _this.selectedRangocita,
              cliId: [value],
              docId: temporalDoctor,
              spcId: temporalEspecialidades,
            };

            ax.post(peticion, data)
              .then((response) => {
                if (response.data.data.length == 0) {
                  _this.datosTabla = 0;
                } else {
                  _this.datosTabla = 1;
                }
                contador = contador + 1;
                if (_this.selectedClinicas.length == contador) {
                  Swal.close();
                }

                response.data.data.forEach(function(value) {
                  _this.items.push(value);
                });
              })
              .catch((error) => {
                contador = contador + 1;
                if (_this.selectedClinicas.length == contador) {
                  Swal.close();
                }
                console.error(error);
              });
          });
        }
      } else {
        if (
          this.selectedRegion == 0 &&
          (this.selectedEspecialidades.length == 0 ||
            this.selectedEspecialidades.includes(0))
        ) {
          Swal.close();
          Swal.fire({
            title: "Esta opcion esta deshabilitada por ahora",
            html: "",
            allowOutsideClick: false,
          });
          return false;
        }
        let temporalEspecialidades;
        if (this.selectedEspecialidades.includes(0)) {
          temporalEspecialidades = [];
        } else {
          temporalEspecialidades = this.selectedEspecialidades;
        }

        var fieldNuevos = [
          {
            key: "zona",
            label: "Región",
            sortable: true,
          },
          {
            key: "dias_esperah",
            label: "Hoy",
            sortable: true,
          },
          {
            key: "dias_espera1s",
            label: "En 1 semana",
            sortable: true,
          },
          {
            key: "dias_espera2s",
            label: "En 2 semana",
            sortable: true,
          },
          {
            key: "dias_espera1m",
            label: "En 1 mes",
            sortable: true,
          },
          {
            key: "dias_espera2m",
            label: "En 2 meses",
            sortable: true,
          },
        ];
        this.fields = fieldNuevos;
        let temporalDoctor;
        let contador = 0;

        if (this.selectedDoctor == 0) {
          temporalDoctor = [];
        }

        let peticion = this.$apiUrl + "obtenerMatrizRegiones" + this.$apiToken;
        this.optionsRegion.forEach(function(value) {
          var data = {
            iniDate: _this.valueFechaInicial,
            endDate: _this.valueFechaFinal,
            cutTime: _this.selectedRangocita,
            cliId: [],
            docId: temporalDoctor,
            spcId: temporalEspecialidades,
            zoneName: value.text,
          };

          ax.post(peticion, data)
            .then((response) => {
              if (response.data.data.length == 0) {
                _this.datosTabla = 0;
              } else {
                _this.datosTabla = 1;
              }
              response.data.data.forEach(function(value) {
                _this.items.push(value);
              });
              contador = contador + 1;
              if (_this.optionsRegion.length == contador) {
                Swal.close();
              }
            })
            .catch((error) => {
              console.error(error);
              contador = contador + 1;
              if (_this.optionsRegion.length == contador) {
                Swal.close();
              }
            });
        });
      }
    },
    actualizarFechaFinal: function() {
      var momentInicial = moment(this.valueFechaInicial).format("YYYY-MM-DD");
      var momentFinal = moment(momentInicial)
        .add(3, "M")
        .format("YYYY-MM-DD");
      this.valueFechaFinal = momentFinal;
    },
    validacionesFormulario: function() {
      if (this.selectedRegion == 0) {
        this.deshabilitarClinicas = true;
        this.deshabilitarDoctor = true;
      } else {
        this.deshabilitarDoctor = false;
        this.deshabilitarClinicas = false;
      }
    },
    obtenerZonas: function() {
      let peticion = this.$apiUrl + "obtenerZonas" + this.$apiToken;
      let objetoZonas = [{ value: 0, text: "TODAS" }];
      ax.get(peticion)
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoZonas.push({ value: value.zone_id, text: value.zone_name });
          });
          this.optionsRegion = objetoZonas;
        })
        .catch();
    },
    obtenerDoctores: function() {
      let temporalClinicas;
      let peticion =
        this.$apiUrl +
        "obtenerDoctoresPorClinicaEspecialidad" +
        this.$apiToken;
      let objetoDoctores = [{ value: 0, text: "TODOS" }];
      if (this.selectedClinicas.length == 0) {
        temporalClinicas = [0];
      } else {
        temporalClinicas = this.selectedClinicas;
      }
      ax.post(peticion, {
        clinicasId: temporalClinicas,
        especialidadesId: this.selectedEspecialidades,
      })
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoDoctores.push({
              value: value.emp_id,
              text: value.per_complete,
            });
          });
          this.optionsDoctores = objetoDoctores;
        })
        .catch();
    },
    obtenerEspecialidades: function() {
      let peticion = this.$apiUrl + "obtenerEspecialidades" + this.$apiToken;
      let objetoEspecialidades = [{ value: 0, text: "TODAS" }];
      ax.get(peticion)
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoEspecialidades.push({
              value: value.spc_id,
              text: value.spc_name,
            });
          });
          this.optionsEspecialidades = objetoEspecialidades;
        })
        .catch();
    },
    obtenerClinicas: function(region) {
      this.deshabilitarRangoCita();
      let params = { zonaId: [region] };

      let objetoClinicas = [];
      let peticion = this.$apiUrl + "obtenerClinicas" + this.$apiToken;
      ax.get(peticion, { params: params })
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoClinicas.push({ value: value.cli_id, text: value.cli_name });
          });
          this.validacionesFormulario();
        })
        .catch();
      this.optionsClinicas = objetoClinicas;
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerZonas();
    this.obtenerClinicas([0]);
    this.obtenerEspecialidades();
    this.obtenerDoctores();
    this.deshabilitarRangoCita();
  },
  mounted() {},
  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<style scoped>
.template {
  width: 100%;
}

.headerTxt {
  font-weight: bold;
}

.SearchPti {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.bolderTxt {
  font-size: 14px;
  font-weight: bolder;
  width: 20%;
  margin-left: 15px;
}

#patientSelect {
  padding-left: 25px;
  padding-right: 25px;
}
.bodyCenter {
}
.modalStyle {
}
.filaunofiltro {
}
.entradasreporte {
  padding: 10px;
}
.labelderecha {
  margin-right: 15px;
  margin-top: 10px;
}
.muevecalendario {
  margin-top: 15px;
}
.botonesmargin {
  margin: 20px;
}
.multipleselect {
  display: flex;
  align-items: flex-start;
}
.labelmultiselect {
  margin-top: 18px;
  margin-right: 15px;
}
</style>
